import React, {FC} from 'react';
import {connect} from 'react-redux';

import {makeGetAuthorFromCommentActivity} from '../../../../../../srcCommon/inboxes/viewer/activity/comment/commentTombstoneSelectors';
import {makeMapStateToProps, ResolveStateProps} from '../../../../../helpers/reselectHelpers';
import {
  ActivityModel,
  ActivityVisualTypesEnum,
  CommentActivityModel,
} from '../../../../../models/api/activityModel';
import {CommentTombstone} from './commentTombstone';
import {recentActivityThreshold} from './commentViewer';

/*
 * Props.
 */

export interface CommentTombstoneContainerProps {
  activity: CommentActivityModel;
  previousActivity: ActivityModel | undefined;
}

type CommentTombstoneStateProps = ResolveStateProps<typeof mapStateToProps>;

type CommentTombstoneContainerComponentProps = CommentTombstoneContainerProps & CommentTombstoneStateProps;

/*
 * Component.
 */

const CommentTombstoneContainerComponent: FC<CommentTombstoneContainerComponentProps> = (props) => {
  const {activity, previousActivity, author} = props;

  const hasSameAuthorAsPrevious = Boolean(
    previousActivity &&
      previousActivity.visualType === ActivityVisualTypesEnum.COMMENT &&
      previousActivity.authorId &&
      author &&
      author.id === previousActivity.authorId,
  );

  const previousActivityDelta = previousActivity && activity.date - previousActivity.date;
  const isPreviousActivityRecent = previousActivityDelta
    ? previousActivityDelta < recentActivityThreshold
    : false;
  const shouldHideTitle = hasSameAuthorAsPrevious;
  const shouldHideTimestamp = hasSameAuthorAsPrevious && isPreviousActivityRecent;

  return (
    <CommentTombstone
      shouldHideTimestamp={shouldHideTimestamp}
      shouldHideTitle={shouldHideTitle}
      author={author}
      date={activity.date}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentTombstoneContainerProps>()(() => ({
  author: makeGetAuthorFromCommentActivity(),
}));

export const CommentTombstoneContainer = connect(mapStateToProps)(CommentTombstoneContainerComponent);
